import { apiGet, apiPost } from './index'

// 获取活动列表
const getTrainList = (params) => apiGet('/api/training/academic/activities/mobile', params)

// 活动签到
const trainSingUp = (params) => apiPost('/api/training/academic/activity/signs', params)

// 活动详情
const trainDetails = (params) => apiGet(`/api/training/academic/activities/mobile/${params.trainId}/${params.iepUserId}`)

// 活动详情-课程列表
const trainDetailsCourse = (params) => apiGet(`/api/training/academic/activity/courses/mobile/${params.trainId}/${params.iepUserId}`)

// 活动详情-学员列表
const trainDetailstudent = (params) => apiGet(`/api/training/academic/activity/students/mobile`, params)

// 活动详情-日程列表
const trainDetailSchedules = (params) => apiGet(`/api/training/academic/activity/schedules/mobile`, params)

// 活动详情-提交评价
const trainEvaluate = (params) => apiPost(`/api/training/academic/activity/feedbacks`, params)

// 活动详情-获取评价
const trainGetEvaluate = (params) => apiGet(`/api/training/academic/activity/feedbacks`, params)

// 判断当前登录人是否有权限看活动详情
const trainCheck = (params) => apiGet(`/api/training/academic/activities/check`, params)

export {
  getTrainList,
  trainSingUp,
  trainDetails,
  trainDetailsCourse,
  trainDetailstudent,
  trainDetailSchedules,
  trainEvaluate,
  trainGetEvaluate,
  trainCheck
}



// WEBPACK FOOTER //
// ./src/api/train.js